export const TIPOS_DE_OBJETO_DA_LICITACAO = [
    { label: 'Obras e serviços de engenharia', value: 'Obras e serviços de engenharia' },
    { label: 'Compras e serviços', value: 'Compras e serviços' },
    { label: 'Alienação', value: 'Alienação' },
    { label: 'Locação', value: 'Locação' }
];



// WEBPACK FOOTER //
// ./src/app/_mocks/tiposDeObjetoDaLicitacao.ts